import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    private _title: string;
    get title(): string {
        return this._title;
    }
    @Input() set title(value: string) {
        this._title = value;
    }

    constructor() {}

    ngOnInit(): void {}
}
